// @flow

// Note: mParticle integration has been removed.
// This is more Tag Manager stuff now...

import serverProps from '../../transfer/utils/serverProps'
import { ANALYTICS_FLOW_TYPE } from '../../../../lib/constants'
import * as fpti from './fpti'
import { getSubFlow } from './utils'
import Events from './eventTags'

const { analyticsFlow, user = {}, appVersion, env } = serverProps
const sessionID = (serverProps.ts && serverProps.ts.vt) || ''
const deviceInfo = serverProps.deviceInfo || {}
const senderAccountType =
  typeof user.userAccountType === 'string'
    ? user.userAccountType.toLowerCase()
    : 'unknown'

// Use in case the flow type doesn't match the expected instrumentation source
const analyticsFlows = {
  [ANALYTICS_FLOW_TYPE.NAV_HEADER]: 'top_header_send_link',
  [ANALYTICS_FLOW_TYPE.SUMMARY_RESEND]: 'summary_quick_send',
  [ANALYTICS_FLOW_TYPE.SUMMARY_LINK]: 'summary_quick_link',
  [ANALYTICS_FLOW_TYPE.PP_ME]: 'pp_me',
  [ANALYTICS_FLOW_TYPE.MESSAGES]: 'messaging',
}

const source = analyticsFlows[analyticsFlow] || analyticsFlow || 'unknown'

Events.initCommonProps({
  // props for code generator
  sender_account_type: senderAccountType,
  sender_country: user.userCountry,
  session_id: sessionID,
  source,
  sub_flow: getSubFlow(env),
  // props for tag manager
  comp: 'p2pnodeweb',
  app_version: appVersion,
  channel: serverProps.isMobile ? 'mweb' : 'web',
  encr_cust_id: user.customerId,
  acnt: senderAccountType, // sender_account_type
  user_country: user.userCountry, // sender_country
  browser_type: deviceInfo.browserName || 'unknown',
  browser_version: deviceInfo.browserVersion || 'unknown',
  operating_system: deviceInfo.osName || 'unknown',
  operating_system_version: deviceInfo.osVersion || 'unknown',
  p2p_contacts_synced_current_app_permissions: 'not_applicable',
})

/**
 *  Tracks links/buttons on a page
 *  @param {Object} [data] data to send to FPTI
 */
export const tracking = fpti.whenReady((data = {}) => {
  fpti.analytics.record({ data })
})
